import React from 'react';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PaymentFailed: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state as { reason?: string } | undefined) || {};
  const rawReason = (state.reason || '').trim();
  const shouldHideReason = /\b(max|maximum|min|minimum|limit|limited)\b/i.test(rawReason);
  const message = shouldHideReason || !rawReason
    ? t('payment.failedMessage')
    : rawReason;

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="flex justify-center mb-4">
          <XCircleIcon className="h-14 w-14 text-red-500" />
        </div>
        <h1 className="text-2xl font-bold text-secondary mb-2">
          {t('payment.failed')}
        </h1>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate('/deposit')}
            className="inline-flex items-center px-4 py-2 rounded-md bg-primary-600 text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            {t('payment.retryPayment')}
          </button>
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center px-4 py-2 rounded-md bg-gray-100 text-secondary hover:bg-gray-200"
          >
            {t('payment.goToDashboard')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;


